import { useContext } from 'react';
import ConfirmationContext from './ConfirmationContext';

export default () => useContext(ConfirmationContext);
